import { get, post, put, destroy } from '@/api/request';

function fetchPolicy() {
  return get('/policy');
}

function createPolicy(data) {
  return post('/policy', data);
}

function updatePolicy(data) {
  return put('/policy', data);
}

function acceptPolicy() {
  return put('/policy/accept');
}

function deletePolicy(id) {
  return destroy(`/policy/${id}`);
}

export default {
  fetchPolicy,
  createPolicy,
  updatePolicy,
  acceptPolicy,
  deletePolicy,
};



// WEBPACK FOOTER //
// ./src/store/modules/policy/api.js